<template>
  <div class="tabs-container">
    <div :class="isTheme ? 'tab-list-theme' : 'tab-list'">
      <button
        v-for="tab in tabs"
        :key="tab.value"
        :class="[
          isTheme ? 'tab-trigger-theme' : 'tab-trigger', 
          { active: internalValue === tab.value },
          { disabled: disabled }
        ]"
        @click="updateValue(tab.value)"
      >
        {{ tab.label }}
      </button>
    </div>

    <div class="tab-content">
      <slot :active="internalValue" />
    </div>
  </div>
</template>

<script>
export default {
  name: "TabsShadcn",
  props: {
    value: {
      type: String,
      default: "",
    },
    tabs: {
      type: Array,
      required: true,
    },
    isTheme: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      internalValue: this.value || (this.tabs[0] && this.tabs[0].value),
    };
  },
  watch: {
    value(val) {
      this.internalValue = val;
    },
  },
  methods: {
    updateValue(val) {
      if(this.disabled) return;
      this.internalValue = val;
      this.$emit("input", val);
    },
  },
};
</script>

<style scoped>
.tabs-container {
  width: 100%;
}

.tab-list {
  display: flex;
  background-color: #f3f4f6;
  padding: 4px;
  border-radius: 8px;
}

.tab-trigger {
  flex: 1;
  text-align: center;
  border: none;
  background: transparent;
  padding: 10px 0;
  border-radius: 6px;
  color: #6b7280;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.tab-trigger.active {
  background-color: #ffffff;
  color: #111827;
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.tab-trigger:hover {
  color: #374151;
}

.tab-list-theme {
  display: flex;
  background-color: var(--background-color-secondary, #f3f4f6);
  padding: 4px;
  border-radius: 8px;
}

.tab-trigger-theme {
  flex: 1;
  text-align: center;
  border: none;
  background: transparent;
  padding: 10px 0;
  border-radius: 6px;
  color: var(--tab-text-color, #6b7280);
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;
}

.tab-trigger-theme.active {
  background-color: var(--background-color-primary, #ffffff);
  color: var(--primary-color, #111827);
  font-weight: 600;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
}

.tab-trigger-theme:hover {
  color: var(--tab-hover-color, #374151);
}

.tab-content {
  margin-top: 16px;
}

.tab-trigger-theme.disabled {
  cursor: no-drop;
}

.tab-trigger.disabled {
  cursor: no-drop;
}
</style>
